// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as enums from '@trialcard/enums';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';


export enum PriorAuthorizationStatus {
    submitted = 'submitted',
    incomplete = 'incomplete',
    rejected = 'rejected',
    approved = 'approved',
    denied = 'denied',
    pending = 'pending',
    pending_denail = 'pending_denial',
    draft = 'draft'
}
